var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.props.row.devices),function(device,index){return _c('ul',{key:index},[_c('li',[_vm._v(_vm._s(device[_vm.props.column.mapField]))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }